import { api } from "./api";
import {
  listInspections,
  saveInspection,
  getPhotoBlob,
  removePhotoBlob,
  inspectionsStore,
} from "./db";

let syncing = false;

/* Upload any local (not-yet-uploaded) photos for an inspection, then PUT it. */
export async function pushInspection(insp) {
  const photos = insp.photos || [];
  for (const ph of photos) {
    if (!ph.uploaded && ph.localId) {
      const blob = await getPhotoBlob(ph.localId);
      if (blob) {
        const form = new FormData();
        const filename = ph.filename || `photo-${ph.localId}.jpg`;
        form.append("file", blob, filename);
        form.append("caption", ph.caption || "");
        form.append("category", ph.category || "");
        const { data } = await api.post("/upload", form, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        ph.fileId = data.id;
        ph.storage_path = data.storage_path;
        ph.content_type = data.content_type;
        ph.uploaded = true;
        await removePhotoBlob(ph.localId);
      }
    }
  }
  const payload = {
    client_id: insp.client_id,
    title: insp.title || "",
    data: insp.data || {},
    photos: photos.map((p) => ({
      id: p.fileId || p.localId,
      localId: p.localId,
      fileId: p.fileId,
      storage_path: p.storage_path,
      content_type: p.content_type,
      caption: p.caption || "",
      category: p.category || "",
      uploaded: !!p.uploaded,
    })),
    status: insp.status || "draft",
    created_at: insp.created_at,
    updated_at: insp.updated_at,
  };
  await api.put(`/inspections/${insp.client_id}`, payload);
  insp.photos = photos;
  insp.dirty = false;
  insp.synced = true;
  insp.syncedAt = new Date().toISOString();
  await inspectionsStore.setItem(insp.client_id, insp);
  return insp;
}

/* Pull server inspections and merge those we don't have locally. */
export async function pullInspections() {
  const { data } = await api.get("/inspections");
  const local = await listInspections();
  const localIds = new Set(local.map((i) => i.client_id));
  for (const remote of data.inspections || []) {
    if (!localIds.has(remote.client_id)) {
      await saveInspection({
        ...remote,
        photos: (remote.photos || []).map((p) => ({ ...p, uploaded: true })),
        dirty: false,
        synced: true,
      });
    }
  }
}

export async function syncAll() {
  if (syncing || !navigator.onLine) return { ok: false };
  syncing = true;
  let pushed = 0;
  try {
    await pullInspections();
    const local = await listInspections();
    for (const insp of local) {
      if (insp.dirty) {
        try {
          await pushInspection(insp);
          pushed++;
        } catch (e) {
          /* keep dirty, retry later */
        }
      }
    }
  } finally {
    syncing = false;
  }
  return { ok: true, pushed };
}

export async function countPending() {
  const local = await listInspections();
  return local.filter((i) => i.dirty).length;
}
